<template>
	<div class="content-class">
		<v-tabs color="black" dark slider-color="primary">
			<v-tab ripple>Groupes de bots</v-tab>
		</v-tabs>
		<bot-groups-list url="bot-groups" />
	</div>
</template>

<script>
import BotGroupsList from '../../components/botGroups/botGroups.list'

export default {
	components: { BotGroupsList },
}
</script>

<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/botGroups/botGroups.list.vue